// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Personalization */
.BC-Page__Personalization .Polaris-Layout__Section .Polaris-Card {
  padding: 20px;
  box-shadow: none;
  border-radius: 8px;
  border: 1px solid var(--border-divider, #e1e3e5);
}

.BC-Page__Personalization .metric .content {
  color: #6d7175;
  margin-top: 4px;
}

.BC-Page__Personalization .settings-infos {
  display: grid;
  gap: 16px;
}

.BC-Page__Personalization .metric-box {
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
  height: 162px;
  margin-top: 15px;
  position: relative;
}

.BC-Page__Personalization .metric-box .metric-box-content {
  padding: 12px;
}

.BC-Page__Personalization .metric-box.metric-box-high {
  width: 44%;
  background-color: #f5fffd;
  border-color: #b6eadd;
  margin-right: 15px;
}

.BC-Page__Personalization .metric-box.metric-box-medium {
  width: 28%;
  background-color: #f0f7ff;
  border-color: #b9d7f8;
  margin-right: 7.5px;
}

.BC-Page__Personalization .metric-box.metric-box-low {
  width: 28%;
  background-color: #fafafb;
  border-color: #e1e3e5;
  margin-left: 7.5px;
}

.BC-Page__Personalization .metric-box-text {
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  text-align: center;
  gap: 4px;
  height: 100%;
  padding: 2px 8px 2px 6px;
}

.BC-Page__Personalization .metric-box-text.metric-box-text-high {
  background-color: #dafbf3;
}

.BC-Page__Personalization .metric-box-text.metric-box-text-medium {
  background-color: #e4f7fa;
}

.BC-Page__Personalization .metric-box-text.metric-box-text-low {
  background-color: #edeeef;
}

.BC-Page__Personalization .metric-box-text .metric-box-text-level-high {
  color: #008060;
}

.BC-Page__Personalization .metric-box-text .metric-box-text-level-medium {
  color: #2c6ecb;
}

.BC-Page__Personalization .metric-box-text .metric-box-text-level-low {
  color: #6d7175;
}

.BC-Page__Personalization .metric-box-description {
  color: #6d7175;
}

.BC-Page__Personalization .metric-box-description-high {
  width: 70%;
  bottom: 15px;
  position: absolute;
}

.BC-Page__Personalization .metric-box-description-medium {
  padding-right: 10px;
  bottom: 15px;
  position: absolute;
}

.BC-Page__Personalization .metric-box-description-low {
  padding-right: 10px;
  bottom: 15px;
  position: absolute;
}

.BC-Page__Personalization .metric-box-image-high {
  position: absolute;
  right: 10px;
  top: 10px;
}

.BC-Page__Personalization .metric-box-image-medium {
  position: absolute;
  right: 5px;
  top: 5px;
}

.BC-Page__Personalization .metric-box-image-low {
  position: absolute;
  right: 5px;
  top: 5px;
}

.BC-Page__Personalization .settings-infos .default-text-style > span:first-child {
  font-weight: 600 !important;
  line-height: 20px;
}

.personalizationInfos {
  border: 1px solid #95c9b4;
}

.personalizationInfos .pfs-banner-content .pfs-banner-actions {
  position: relative;
  bottom: 0;
  margin-top: 20px;
}

@media (max-width: 1091px) {
  .BC-Page__Personalization .metric-box-image-high > img {
    width: 120px;
    height: 120px;
  }

  .BC-Page__Personalization .metric-box-image-medium > img {
    width: 90px;
    height: 90px;
  }

  .BC-Page__Personalization .metric-box-image-low > img {
    width: 90px;
    height: 90px;
  }
}

@media (max-width: 962px) {
  .BC-Page__Personalization .metric-box-image-high > img {
    width: 90px;
    height: 90px;
  }

  .BC-Page__Personalization .metric-box-image-medium > img {
    width: 60px;
    height: 60px;
  }

  .BC-Page__Personalization .metric-box-image-low > img {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 836px) {
  .BC-Page__Personalization .metric-box-image-high > img {
    width: 40px;
    height: 40px;
  }

  .BC-Page__Personalization .metric-box-image-medium > img {
    width: 40px;
    height: 40px;
  }

  .BC-Page__Personalization .metric-box-image-low > img {
    width: 40px;
    height: 40px;
  }
}

.BC-Page__Personalization .weight-dot {
  border-radius: 50%;
  width: 8px;
  height: 8px;
}

.BC-Page__Personalization .weight-dot-high {
  background: #007f5f;
}

.BC-Page__Personalization .weight-dot-medium {
  background: #2c6ecb;
}

.BC-Page__Personalization .weight-dot-low {
  background: #5c5f62;
}

.BC-Page__Personalization .premium-lock-card .Polaris-Card__Section {
  padding: 0 1.5rem;
}

.BC-Page__Personalization .pfs-banner-detail .image img {
  margin-bottom: 10px;
}

.BC-Page__Personalization .table-features table {
  border-radius: 8px;
  border: var(--p-border-divider);
  margin-bottom: 8px;
}

.BC-Page__Personalization .table-features td {
  font-weight: 600;
}

.BC-Page__Personalization .table-features .action .settings-icon .Polaris-Icon,
.BC-Page__Personalization .table-features .action img {
  width: 16px;
  height: 16px;
}

.BC-Page__Personalization .table-features .action .wrap-icon {
  width: 28px;
  height: 28px;
  border: 1px solid #c9cccf;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.BC-Page__Personalization .table-features .action.action-1-item .wrap-icon {
  border-radius: 3px;
}

.BC-Page__Personalization .table-features .action.action-2-item > :first-child .wrap-icon {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.BC-Page__Personalization .table-features .action.action-2-item > :nth-child(2) .wrap-icon {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-left: none;
}

.BC-Page__Personalization .table-features .feature-wrapper > * {
  margin-top: 4px;
}
/* End Personalization */

/* Present banner */
.SearchPersonalizationPresent-Popup-Container .Polaris-Backdrop {
  z-index: 529;
}

.SearchPersonalizationPresent-Popup-Container .Polaris-Modal-Dialog__Container {
  z-index: 530;
}
.SearchPersonalizationPresent-Popup-Container .Polaris-Modal-Dialog__Modal {
  min-width: 816px !important;
  max-width: 816px !important;
  background: none;
}
.SearchPersonalizationPresent-Popup {
  position: relative;
  width: 816px;
  height: 530px;
  overflow: hidden;
}
.SearchPersonalizationPresent-Popup map {
  position: absolute;
  top: 0;
  left: 0;
}
.SearchPersonalizationPresent-Popup img {
  width: 816px;
  height: 532px;
}
.SearchPersonalizationPresent-Popup .closeBtn {
  position: absolute;
  top: 16px;
  right: 16px;
}

.SearchPersonalizationPresent-Banner-Container {
  position: relative;
  overflow: hidden;
  padding: 0 20px;
  border-radius: 8px;
  background-color: #0e121d;
  background-image: url('https://cdn.boostcommerce.io/assets/advance-search/gradient-horizontal.png');
  background-size: 135% 100%;
}

.SearchPersonalizationPresent-Banner-Container .banner-dismiss {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 12;
}

.SearchPersonalizationPresent-Banner-Container .banner-detail {
  margin-top: 4px;
  display: flex;
  justify-content: space-around;
  grid-gap: 20px;
  gap: 20px;
}

.SearchPersonalizationPresent-Banner-Container .banner-detail .banner-content {
  width: 60%;
}

.SearchPersonalizationPresent-Banner-Container .banner-detail .title {
  margin-top: 20px;
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  background: linear-gradient(180deg, #ffffff 18.18%, rgba(255, 255, 255, 0.66) 80.7%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.SearchPersonalizationPresent-Banner-Container .banner-detail p {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.9;
  margin-top: 4px;
}

.SearchPersonalizationPresent-Banner-Container .banner-detail .Polaris-Button--destructive,
.SearchPersonalizationPresent-Banner-Vertical-Container
  .banner-detail
  .Polaris-Button--destructive {
  margin: 1rem 0;
  --pc-button-color: #ff5f6d;
}

.SearchPersonalizationPresent-Banner-Container .banner-detail .Polaris-Button__Text,
.SearchPersonalizationPresent-Banner-Vertical-Container .banner-detail .Polaris-Button__Text {
  display: flex;
  align-items: center;
  grid-gap: 8px;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.SearchPersonalizationPresent-Banner-Container .banner-detail .image {
  width: 40%;
  max-width: 326px;
  z-index: 10;
}

.SearchPersonalizationPresent-Banner-Container .banner-detail .image img,
.SearchPersonalizationPresent-Banner-Vertical-Container .banner-detail .image img {
  width: 100%;
  height: auto;
}

/* Additional for Vertical banner */
.SearchPersonalizationPresent-Banner-Vertical-Container {
  margin-right: 8px;
  margin-top: 8px;
  padding: 12px 8px 0;
  text-align: center;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  background-color: #0e121d;
  background-image: url('https://cdn.boostcommerce.io/assets/advance-search/gradient-vertical.png');
  background-size: 100% 150%;
}

.SearchPersonalizationPresent-Banner-Vertical-Container .banner-content {
  margin-top: 1rem;
}

.SearchPersonalizationPresent-Banner-Vertical-Container .banner-detail .title {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
}

.SearchPersonalizationPresent-Banner-Vertical-Container .banner-detail p {
  margin-top: 4px;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.9;
}

.SearchPersonalizationPresent-Banner-Vertical-Container .banner-detail .image {
  max-width: 168px;
  z-index: 10;
}

/* End Present banner */

/* Klaviyo banner */
.klaviyoPromoteBanner {
  margin-top: 1.5rem;
  padding: 5px 16px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #fff2f9 10.15%, #e8f7ff 105.86%);
  border: 1px solid rgba(243, 119, 77, 0.16);
  border-radius: 8px;
  text-align: left;
}

.klaviyoPromoteBanner .title {
  align-items: center;
  position: relative;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.klaviyoPromoteBanner .title img {
  margin-right: 2px;
}

.klaviyoPromoteBanner .title > span,
.klaviyoPromoteBanner .title .title-content {
  display: flex;
  align-items: center;
}

.klaviyoPromoteBanner .title .title-content img {
  margin-right: 5px;
}

.klaviyoPromoteBanner .pfs-banner-detail {
  margin-top: 0px;
}

.klaviyoPromoteBanner .pfs-banner-content {
  display: flex;
  padding: 0;
  padding-left: 20px;
}

.klaviyoPromoteBanner .action {
  position: absolute;
  right: 0;
}

.klaviyoPromoteBanner .backgroundImage img {
  max-width: 52px;
}
/* end banner */
`, "",{"version":3,"sources":["webpack://./src/styles/personalization.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;AACA,wBAAwB;;AAExB,mBAAmB;AACnB;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mGAAmG;EACnG,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oFAAoF;EACpF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iGAAiG;EACjG,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,uBAAuB;;AAEvB,mBAAmB;AACnB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,oEAAoE;EACpE,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;AACA,eAAe","sourcesContent":["/* Personalization */\n.BC-Page__Personalization .Polaris-Layout__Section .Polaris-Card {\n  padding: 20px;\n  box-shadow: none;\n  border-radius: 8px;\n  border: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.BC-Page__Personalization .metric .content {\n  color: #6d7175;\n  margin-top: 4px;\n}\n\n.BC-Page__Personalization .settings-infos {\n  display: grid;\n  gap: 16px;\n}\n\n.BC-Page__Personalization .metric-box {\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 8px;\n  height: 162px;\n  margin-top: 15px;\n  position: relative;\n}\n\n.BC-Page__Personalization .metric-box .metric-box-content {\n  padding: 12px;\n}\n\n.BC-Page__Personalization .metric-box.metric-box-high {\n  width: 44%;\n  background-color: #f5fffd;\n  border-color: #b6eadd;\n  margin-right: 15px;\n}\n\n.BC-Page__Personalization .metric-box.metric-box-medium {\n  width: 28%;\n  background-color: #f0f7ff;\n  border-color: #b9d7f8;\n  margin-right: 7.5px;\n}\n\n.BC-Page__Personalization .metric-box.metric-box-low {\n  width: 28%;\n  background-color: #fafafb;\n  border-color: #e1e3e5;\n  margin-left: 7.5px;\n}\n\n.BC-Page__Personalization .metric-box-text {\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  text-align: center;\n  gap: 4px;\n  height: 100%;\n  padding: 2px 8px 2px 6px;\n}\n\n.BC-Page__Personalization .metric-box-text.metric-box-text-high {\n  background-color: #dafbf3;\n}\n\n.BC-Page__Personalization .metric-box-text.metric-box-text-medium {\n  background-color: #e4f7fa;\n}\n\n.BC-Page__Personalization .metric-box-text.metric-box-text-low {\n  background-color: #edeeef;\n}\n\n.BC-Page__Personalization .metric-box-text .metric-box-text-level-high {\n  color: #008060;\n}\n\n.BC-Page__Personalization .metric-box-text .metric-box-text-level-medium {\n  color: #2c6ecb;\n}\n\n.BC-Page__Personalization .metric-box-text .metric-box-text-level-low {\n  color: #6d7175;\n}\n\n.BC-Page__Personalization .metric-box-description {\n  color: #6d7175;\n}\n\n.BC-Page__Personalization .metric-box-description-high {\n  width: 70%;\n  bottom: 15px;\n  position: absolute;\n}\n\n.BC-Page__Personalization .metric-box-description-medium {\n  padding-right: 10px;\n  bottom: 15px;\n  position: absolute;\n}\n\n.BC-Page__Personalization .metric-box-description-low {\n  padding-right: 10px;\n  bottom: 15px;\n  position: absolute;\n}\n\n.BC-Page__Personalization .metric-box-image-high {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.BC-Page__Personalization .metric-box-image-medium {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n}\n\n.BC-Page__Personalization .metric-box-image-low {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n}\n\n.BC-Page__Personalization .settings-infos .default-text-style > span:first-child {\n  font-weight: 600 !important;\n  line-height: 20px;\n}\n\n.personalizationInfos {\n  border: 1px solid #95c9b4;\n}\n\n.personalizationInfos .pfs-banner-content .pfs-banner-actions {\n  position: relative;\n  bottom: 0;\n  margin-top: 20px;\n}\n\n@media (max-width: 1091px) {\n  .BC-Page__Personalization .metric-box-image-high > img {\n    width: 120px;\n    height: 120px;\n  }\n\n  .BC-Page__Personalization .metric-box-image-medium > img {\n    width: 90px;\n    height: 90px;\n  }\n\n  .BC-Page__Personalization .metric-box-image-low > img {\n    width: 90px;\n    height: 90px;\n  }\n}\n\n@media (max-width: 962px) {\n  .BC-Page__Personalization .metric-box-image-high > img {\n    width: 90px;\n    height: 90px;\n  }\n\n  .BC-Page__Personalization .metric-box-image-medium > img {\n    width: 60px;\n    height: 60px;\n  }\n\n  .BC-Page__Personalization .metric-box-image-low > img {\n    width: 60px;\n    height: 60px;\n  }\n}\n\n@media (max-width: 836px) {\n  .BC-Page__Personalization .metric-box-image-high > img {\n    width: 40px;\n    height: 40px;\n  }\n\n  .BC-Page__Personalization .metric-box-image-medium > img {\n    width: 40px;\n    height: 40px;\n  }\n\n  .BC-Page__Personalization .metric-box-image-low > img {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n.BC-Page__Personalization .weight-dot {\n  border-radius: 50%;\n  width: 8px;\n  height: 8px;\n}\n\n.BC-Page__Personalization .weight-dot-high {\n  background: #007f5f;\n}\n\n.BC-Page__Personalization .weight-dot-medium {\n  background: #2c6ecb;\n}\n\n.BC-Page__Personalization .weight-dot-low {\n  background: #5c5f62;\n}\n\n.BC-Page__Personalization .premium-lock-card .Polaris-Card__Section {\n  padding: 0 1.5rem;\n}\n\n.BC-Page__Personalization .pfs-banner-detail .image img {\n  margin-bottom: 10px;\n}\n\n.BC-Page__Personalization .table-features table {\n  border-radius: 8px;\n  border: var(--p-border-divider);\n  margin-bottom: 8px;\n}\n\n.BC-Page__Personalization .table-features td {\n  font-weight: 600;\n}\n\n.BC-Page__Personalization .table-features .action .settings-icon .Polaris-Icon,\n.BC-Page__Personalization .table-features .action img {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Page__Personalization .table-features .action .wrap-icon {\n  width: 28px;\n  height: 28px;\n  border: 1px solid #c9cccf;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.BC-Page__Personalization .table-features .action.action-1-item .wrap-icon {\n  border-radius: 3px;\n}\n\n.BC-Page__Personalization .table-features .action.action-2-item > :first-child .wrap-icon {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.BC-Page__Personalization .table-features .action.action-2-item > :nth-child(2) .wrap-icon {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  border-left: none;\n}\n\n.BC-Page__Personalization .table-features .feature-wrapper > * {\n  margin-top: 4px;\n}\n/* End Personalization */\n\n/* Present banner */\n.SearchPersonalizationPresent-Popup-Container .Polaris-Backdrop {\n  z-index: 529;\n}\n\n.SearchPersonalizationPresent-Popup-Container .Polaris-Modal-Dialog__Container {\n  z-index: 530;\n}\n.SearchPersonalizationPresent-Popup-Container .Polaris-Modal-Dialog__Modal {\n  min-width: 816px !important;\n  max-width: 816px !important;\n  background: none;\n}\n.SearchPersonalizationPresent-Popup {\n  position: relative;\n  width: 816px;\n  height: 530px;\n  overflow: hidden;\n}\n.SearchPersonalizationPresent-Popup map {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.SearchPersonalizationPresent-Popup img {\n  width: 816px;\n  height: 532px;\n}\n.SearchPersonalizationPresent-Popup .closeBtn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n}\n\n.SearchPersonalizationPresent-Banner-Container {\n  position: relative;\n  overflow: hidden;\n  padding: 0 20px;\n  border-radius: 8px;\n  background-color: #0e121d;\n  background-image: url('https://cdn.boostcommerce.io/assets/advance-search/gradient-horizontal.png');\n  background-size: 135% 100%;\n}\n\n.SearchPersonalizationPresent-Banner-Container .banner-dismiss {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 12;\n}\n\n.SearchPersonalizationPresent-Banner-Container .banner-detail {\n  margin-top: 4px;\n  display: flex;\n  justify-content: space-around;\n  grid-gap: 20px;\n  gap: 20px;\n}\n\n.SearchPersonalizationPresent-Banner-Container .banner-detail .banner-content {\n  width: 60%;\n}\n\n.SearchPersonalizationPresent-Banner-Container .banner-detail .title {\n  margin-top: 20px;\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 32px;\n  background: linear-gradient(180deg, #ffffff 18.18%, rgba(255, 255, 255, 0.66) 80.7%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.SearchPersonalizationPresent-Banner-Container .banner-detail p {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: #ffffff;\n  opacity: 0.9;\n  margin-top: 4px;\n}\n\n.SearchPersonalizationPresent-Banner-Container .banner-detail .Polaris-Button--destructive,\n.SearchPersonalizationPresent-Banner-Vertical-Container\n  .banner-detail\n  .Polaris-Button--destructive {\n  margin: 1rem 0;\n  --pc-button-color: #ff5f6d;\n}\n\n.SearchPersonalizationPresent-Banner-Container .banner-detail .Polaris-Button__Text,\n.SearchPersonalizationPresent-Banner-Vertical-Container .banner-detail .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n  grid-gap: 8px;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n}\n\n.SearchPersonalizationPresent-Banner-Container .banner-detail .image {\n  width: 40%;\n  max-width: 326px;\n  z-index: 10;\n}\n\n.SearchPersonalizationPresent-Banner-Container .banner-detail .image img,\n.SearchPersonalizationPresent-Banner-Vertical-Container .banner-detail .image img {\n  width: 100%;\n  height: auto;\n}\n\n/* Additional for Vertical banner */\n.SearchPersonalizationPresent-Banner-Vertical-Container {\n  margin-right: 8px;\n  margin-top: 8px;\n  padding: 12px 8px 0;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px;\n  background-color: #0e121d;\n  background-image: url('https://cdn.boostcommerce.io/assets/advance-search/gradient-vertical.png');\n  background-size: 100% 150%;\n}\n\n.SearchPersonalizationPresent-Banner-Vertical-Container .banner-content {\n  margin-top: 1rem;\n}\n\n.SearchPersonalizationPresent-Banner-Vertical-Container .banner-detail .title {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n  color: #ffffff;\n}\n\n.SearchPersonalizationPresent-Banner-Vertical-Container .banner-detail p {\n  margin-top: 4px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: #ffffff;\n  opacity: 0.9;\n}\n\n.SearchPersonalizationPresent-Banner-Vertical-Container .banner-detail .image {\n  max-width: 168px;\n  z-index: 10;\n}\n\n/* End Present banner */\n\n/* Klaviyo banner */\n.klaviyoPromoteBanner {\n  margin-top: 1.5rem;\n  padding: 5px 16px;\n  box-sizing: border-box;\n  background: linear-gradient(180deg, #fff2f9 10.15%, #e8f7ff 105.86%);\n  border: 1px solid rgba(243, 119, 77, 0.16);\n  border-radius: 8px;\n  text-align: left;\n}\n\n.klaviyoPromoteBanner .title {\n  align-items: center;\n  position: relative;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.klaviyoPromoteBanner .title img {\n  margin-right: 2px;\n}\n\n.klaviyoPromoteBanner .title > span,\n.klaviyoPromoteBanner .title .title-content {\n  display: flex;\n  align-items: center;\n}\n\n.klaviyoPromoteBanner .title .title-content img {\n  margin-right: 5px;\n}\n\n.klaviyoPromoteBanner .pfs-banner-detail {\n  margin-top: 0px;\n}\n\n.klaviyoPromoteBanner .pfs-banner-content {\n  display: flex;\n  padding: 0;\n  padding-left: 20px;\n}\n\n.klaviyoPromoteBanner .action {\n  position: absolute;\n  right: 0;\n}\n\n.klaviyoPromoteBanner .backgroundImage img {\n  max-width: 52px;\n}\n/* end banner */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
